<template>
    <content-view>
        <a-spin :spinning="spinning">
            <div class="wrap-container-in">
                <a-form :form="form">
                    <a-form-item label="优惠类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-radio-group
                            :disabled="isDisable"
                            @change="onChangeType"
                            v-decorator="['discountType',{initialValue: 1}]"
                        >
                            <a-radio :value="1">打折优惠</a-radio>
                            <a-radio :value="2">满减优惠</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="优惠名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input
                        :placeholder="'折扣名称不可与现有'+($route.query.discountTarget == 1 ? '票券' : '零售')+'类型优惠名称重复'"
                        :disabled="isDisable"
                        v-decorator="['name',{rules: [{required: true, message: '请输入优惠名称(20字以内)', max: 20}]}]"
                        style="width: 70%;"
                        />
                    </a-form-item>
                    <a-form-item v-show="showDiscount" label="打折百分比%" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number
                        style="width: 70%"
                        placeholder="请输入0-100间数值,保留两位小数"
                        :disabled="isDisable"
                        :precision="2"
                        v-decorator="['discountPercent',{rules: [{required: showDiscount, message: '请输入打折百分比'}, {pattern: /^([0-9]{1}[0-9]?)([.]{1}\d{1,2}?)?$|^100$|^([0]{1}[.]{1}\d{1,2})$/, message: '请输入0-100间数值,保留两位小数'}]}]"
                        />
                    </a-form-item>
                    <a-form-item v-show="!showDiscount" label="满减金额/元" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number
                        style="width: 70%"
                        :precision="2"
                        placeholder="请输入大于0的数值,保留两位小数"
                        :disabled="isDisable"
                        v-decorator="['reduceAmount',{rules: [{required: !showDiscount, message: '请输入满减金额'}, {pattern: /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,8}\.\d{0,2}$|^[0-9]\d{0,8}$/, message: '请输入大于0的数值,保留两位小数'}]}]"
                        />
                    </a-form-item>
                    <a-form-item label="优惠门槛设置" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-radio-group
                            :disabled="isDisable"
                            @change="onChangeStandard"
                            v-decorator="['satisfy',{initialValue: 0}]"
                        >
                            <a-radio :value="0">无门槛</a-radio>
                            <a-radio :value="1">有门槛</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="showStandard" label="门槛金额/元" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-input-number
                        style="width: 70%"
                        placeholder="请输入大于等于满减金额的数值,保留两位小数"
                        :min="Number(form.getFieldValue('reduceAmount'))"
                        :disabled="isDisable"
                        v-decorator="['satisfyAmount',{rules: [{required: showStandard, message: '请输入门槛金额'}, {pattern: /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,8}\.\d{0,2}$|^[1-9]\d{0,8}$/, message: '请输入大于等于满减金额的数值,保留两位小数'}]}]"
                        />
                    </a-form-item>
                    <a-form-item label="优惠范围" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-radio-group :disabled="isDisable" v-decorator="['discountRange',{initialValue: 1}]">
                            <a-radio :value="1">门店全部{{$route.query.discountTarget == 1 ? '票券' : '零售'}}</a-radio>
                            <a-radio :value="2">门店部分{{$route.query.discountTarget == 1 ? '票券' : '零售'}}</a-radio>
                            <a-button :disabled="isDisable" @click="openTiketList" v-show="form.getFieldValue('discountRange') === 2 && $route.query.discountTarget == 1">选择票券</a-button>
                            <a-button :disabled="isDisable" @click="openRetailList" v-show="form.getFieldValue('discountRange') === 2 && $route.query.discountTarget == 2">选择零售商品</a-button>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="!isDisable && form.getFieldValue('discountRange') === 2 && dataSource.length > 0" :wrapperCol="{span: 15, offset: 4}">
                        <a-button type="primary" @click="goodsLimitDelete" :disabled="goodsLimitSelectedDeleteRowKeys.length === 0">删除</a-button>
                    </a-form-item>
                    <a-form-item v-show="$route.query.discountTarget == 1 && form.getFieldValue('discountRange') === 2 && dataSource.length > 0" :wrapperCol="{span: 15, offset: 4}">
                        <a-table bordered :columns="columns" :dataSource="dataSource" :rowSelection="{onChange: goodsLimitOnchange, onSelectAll: goodsLimitOnSelectAll, selectedRowKeys: goodsLimitSelectedDeleteRowKeys}" :rowKey="record => record.targetId" >
                            <span slot="ticketType" slot-scope="a">{{['', '期限卡', '次卡', '套餐票'][a]}}</span>
                            <template slot="action" slot-scope="a,row">
                                <span v-if="isDisable" class="text-disabled">删除</span>
                                <a v-else class="text-primary" @click="deleteData(row.id)">删除</a>
                            </template>
                        </a-table>
                    </a-form-item>
                    <a-form-item v-show="$route.query.discountTarget == 2 && form.getFieldValue('discountRange') === 2 && dataSource.length > 0" :wrapperCol="{span: 16, offset: 4}">
                        <a-table style="word-break:break-all;" bordered :columns="columnsRetail" :dataSource="dataSource" :rowSelection="{onChange: goodsLimitOnchange,onSelectAll: goodsLimitOnSelectAll, selectedRowKeys: goodsLimitSelectedDeleteRowKeys}" :rowKey="record => record.targetId" >
                            <template slot="price" slot-scope="price">{{price || "-"}}</template>
                            <template slot="action" slot-scope="a,row">
                                <span v-if="isDisable" class="text-disabled">删除</span>
                                <a v-else class="text-primary" @click="batchAddRemove(row.id)">删除</a>
                            </template>
                        </a-table>
                    </a-form-item>
                    <a-form-item label="优惠上架收银台" :labelCol="labelCol" :wrapperCol="{span: 13}">
                        <a-checkbox-group
                            :options="ticketDeskNew"
                            :disabled="isDisable"
                            v-decorator="['shelvePlatformIds',{rules: [{required: true, message: '请选择优惠上架收银台'}]}]"
                        />
                    </a-form-item>
                    <a-form-item label="折扣时间范围" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-range-picker
                            style="width: 70%"
                            format="YYYY-MM-DD"
                            :disabled="isDisable"
                            v-decorator="['shelveDate',{rules: [{required: true, message: '请选择折扣时间范围'}]}]"
                        />
                    </a-form-item>
                    <a-form-item label="上架状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-radio-group
                            :disabled="isDisable"
                            v-decorator="['shelve',{initialValue: 0}]"
                        >
                            <a-radio :value="1">上架</a-radio>
                            <a-radio :value="0">下架</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item label="使用限制" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-radio-group
                            @change="form.setFieldsValue({holdMode: 1, utLimit: 0, utLimitNum: undefined})"
                            :disabled="isDisable"
                            v-decorator="['useLimit',{initialValue: 0}]"
                        >
                            <a-radio :value="0">不限制</a-radio>
                            <a-radio :value="1">限制票券持有者使用</a-radio>
                            <a-button @click="openUserTicketList" :disabled="isDisable" v-show="form.getFieldValue('useLimit') == 1">选择票券</a-button>
                        </a-radio-group>
                    </a-form-item>
                    <!-- 使用限制选择不限制时 -->
                    <!-- 使用限制选择限制票券持有者使用时 -->
                    <a-form-item v-show="form.getFieldValue('useLimit') == 1" label="票券持有方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-radio-group
                            :disabled="isDisable"
                            v-decorator="['holdMode',{initialValue: 1}]"
                        >
                            <a-radio :value="0">当前持有</a-radio>
                            <a-radio :value="1">历史持有</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item :label="form.getFieldValue('useLimit') == 1 ? '用户票券使用次数限制' : '用户使用次数限制'" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-row>
                            <a-col :span="14">
                                <a-radio-group
                                    @change="form.setFieldsValue({utLimitTime: 0, utLimitNum: undefined, utLimitMode: 0})"
                                    :disabled="isDisable"
                                    v-decorator="['utLimit',{initialValue: 0}]"
                                >
                                    <a-radio :value="0">不限制</a-radio>
                                    <a-radio :value="1">限制使用次数</a-radio>
                                </a-radio-group>
                                <a-form-item :style="`margin-bottom:0;display: ${form.getFieldValue('utLimit') == 1 ? 'inline-block' : 'null'}`" v-show="form.getFieldValue('utLimit') == 1">
                                    <a-input-number :min="1" :precision="0"  :disabled="isDisable" v-decorator="['utLimitNum']" /> 次
                                </a-form-item>
                            </a-col>
                            <!-- <a-col :span="8">

                            </a-col> -->
                        </a-row>
                    </a-form-item>
                    <a-form-item v-show="form.getFieldValue('useLimit') == 1 && form.getFieldValue('utLimit') == 1" label="使用次数限制方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-radio-group
                            :disabled="isDisable"
                            v-decorator="['utLimitMode',{initialValue: 0}]"
                        >
                            <a-radio :value="0">固定使用次数</a-radio>
                            <a-radio :value="1">根据用户票券数确定可使用次数</a-radio>
                            <a-tooltip title="拥有n张符合要求的票券，即可使用优惠（n*限制次数）次"><a-icon type="question-circle" /></a-tooltip>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="form.getFieldValue('utLimit') == 1" label="使用次数限制期间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-radio-group
                            :disabled="isDisable"
                            v-decorator="['utLimitTime',{initialValue: 0}]"
                        >
                            <a-radio :value="0">单天（活动期间用户每天可使用的次数固定）</a-radio>
                            <a-radio :value="1">活动期间（活动期间用户可使用的次数固定）</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item v-show="form.getFieldValue('useLimit') === 1 && dataSourceTickets.length > 0" :wrapperCol="{span: 16, offset: 4}">
                        <a-button v-if="!isDisable" @click="batchTicketRemove" class="mb16" type="primary" :disabled="selectedDeleteRowKeys.length === 0">删除</a-button>
                        <a-table :scroll="{y:400}" style="word-break:break-all;" bordered :columns="columnsTickets" :dataSource="dataSourceTickets" :rowSelection="{onChange: onSelectChange, selectedRowKeys: selectedDeleteRowKeys}" :pagination="false" :rowKey="record => record.targetId" >
                            <span slot="ticketType" slot-scope="a">{{['', '期限卡', '次卡', '套餐票'][a]}}</span>
                            <span slot="lineType" slot-scope="a">{{['','线上票','线下票'][a]}}</span>
                            <template slot="shopName" slot-scope="shopName">{{shopName || "-"}}</template>
                            <template slot="price" slot-scope="price">{{price || "-"}}</template>
                            <template slot="action" slot-scope="a,row">
                                <span v-if="isDisable" class="text-disabled">删除</span>
                                <a v-else class="text-primary" @click="ticketRemove(row.targetId)">删除</a>
                            </template>
                        </a-table>
                    </a-form-item>
                </a-form>
                <div class="text-center">
                    <a-button @click="$router.go(-1)">返回</a-button>
                    <a-button v-show="!isDisable" type="primary" @click="onSubmit" :loading="loading">确认</a-button>
                </div>
                <ticket-list @changeVisible="changeVisible" @discountTargetIds="discountTargetIds" :selectedRowKeys="tableSelectedRowKeys" :visible="showTicketList" :list="ticketList"></ticket-list>
                <goods-batch-picker ref="goodsBatchPicker" :selectedRowKeys="selectedRowKeys" :selectedRow="dataSource" @confirm="selectGoodsModalConfirm"></goods-batch-picker>
                <tickets-batch-picker ref="ticketsBatchPicker" :selectedRowKeys="selectedTicketsRowKeys" @confirm="selectTicketssModalConfirm" :ticketList="ticketList"></tickets-batch-picker>
            </div>
        </a-spin>
    </content-view>
</template>

<script>
    import ticketList from "@/components/modules/change-code/ticket-list.component";
    import goodsBatchPicker from "@/components/modules/change-code/goods-batch-picker.component";
    import ticketsBatchPicker from "@/components/modules/change-code/tickets-batch-picker.component";
    import { mapGetters } from "vuex";
    const columns = [
        {
            title: "票券内部标识",
            dataIndex: "ticketName",
        },
        {
            title: "票券类型",
            dataIndex: "ticketType",
            scopedSlots: { customRender: "ticketType" },
            width: 150
        },
        {
            title: "售卖价/元",
            dataIndex: "sellPrice",
            width: 150
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" },
            width: 80
        }
    ];
    const columnsTickets = [
        {
            title: "票券内部标识",
            dataIndex: "ticketName",
            width: 150
        },
        // {
        //     title: "线上线下",
        //     dataIndex: "lineType",
        //     scopedSlots: { customRender: "lineType" },
        //     width: 90
        // },
        // {
        //     title: "所属门店",
        //     dataIndex: "shopName",
        //     scopedSlots: { customRender: "shopName" },
        //     width: 100
        // },
        {
            title: "票券类型",
            dataIndex: "ticketType",
            scopedSlots: { customRender: "ticketType" },
            width: 90
        },
        {
            title: "售卖价/元",
            dataIndex: "sellPrice",
            width: 100
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" },
            width: 60
        }
    ];
    const columnsRetail = [
        {
            title: "商品编号",
            dataIndex: "goodsNo",
            width: 150
        },
        {
            title: "商品名称",
            dataIndex: "goodsName"
        },
        {
            title: "所在仓库",
            dataIndex: "warehouseName",
            width: 100
        },
        {
            title: "所在仓库库存",
            dataIndex: "currentInventory",
            width: 130
        },
        {
            title: "售卖价/元",
            dataIndex: "price",
            scopedSlots: { customRender: "price" },
            width: 100
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" },
            width: 80
        }
    ];
    export default {
        name: 'addSell',
        components: {
            ticketList,
            goodsBatchPicker,
            ticketsBatchPicker,
        },
        computed: {...mapGetters(["shopId"])},
        data() {
            return {
                form: this.$form.createForm(this),
                labelCol: {span: 7},
                wrapperCol: {span: 17},
                columns,
                columnsRetail,
                dataSource: [],
                columnsTickets,
                dataSourceTickets: [],
                // dataSourceRetail: [],
                isDisable: false,
                showTicketList: false,
                ticketDeskNew: [],
                ticketList: [],
                shopTicketList: [],
                showDiscount: true,
                showStandard: false,
                loading: false,
                tableSelectedRowKeys: [],
                selectedRowKeys: [],
                selectedTicketsRowKeys: [],
                selectedDeleteRowKeys: [],
                goodsLimitSelectedDeleteRowKeys: [],
                spinning: false
            }
        },
        mounted() {
            this.getNewPlatformList();
            this.getTicket();
            if (this.$route.name.indexOf('add') == -1) {
                this.getDetail();
            }
            if ( this.$route.name.indexOf('detail') > -1) {
                this.isDisable = true;
            }
        },
        watch: {
            shopId(val) {
                if (!val) return;
                this.getNewPlatformList();
                this.getTicket();
            }
        },
        methods: {
            openTiketList() {
                this.showTicketList = true;
            },
            openRetailList() {
                this.$refs.goodsBatchPicker.visible = true;
            },
            openUserTicketList() {
                this.$refs.ticketsBatchPicker.visible = true;
            },
            onChangeType(e) {
                this.showDiscount = e.target.value === 1;
                this.$nextTick(() => {
                    this.form.validateFields(['discountPercent','reduceAmount','satisfyAmount'], { force: true });
                });
            },
            onChangeStandard(e) {
                this.showStandard = e.target.value === 1;
                this.$nextTick(() => {
                    this.form.resetFields(['satisfyAmount'], { force: true });
                });
            },
            changeVisible() {
                this.showTicketList = false;
            },
            discountTargetIds(val) {
                this.tableSelectedRowKeys = val;
                this.getTableData(val)
            },
            /**
             * @selectGoodsModalConfirm 批量商品选择弹窗确定
             */
            selectGoodsModalConfirm({selectedRowKeys, selectedRows}) {
                this.selectedRowKeys = selectedRowKeys;
                this.dataSource = selectedRows;
            },
            /**
             * @batchAddRemove 批量增加项删除
             */
            batchAddRemove(id) {
                this.selectedRowKeys = this.selectedRowKeys.filter(item => item !== id);
                this.dataSource = this.dataSource.filter(item => item.id !== id);
            },
            /**
             * @selectTicketssModalConfirm 批量票券选择弹窗确定
             */
            selectTicketssModalConfirm({selectedTicketsRowKeys, selectedTicketsRows}) {
                // selectedTicketsRows.forEach(item => {
                //     this.selectedTicketsRowKeys.forEach((key,i) => {
                //         if(item.targetId == key) {
                //             this.selectedTicketsRowKeys.splice(i,1);
                //             this.dataSourceTickets.splice(i,1);
                //         }
                //     })
                // })
                // this.selectedTicketsRowKeys = selectedTicketsRowKeys.concat(this.selectedTicketsRowKeys);
                // this.dataSourceTickets = selectedTicketsRows.concat(this.dataSourceTickets);
                this.selectedTicketsRowKeys = selectedTicketsRowKeys;
                this.dataSourceTickets = selectedTicketsRows;
            },
            /**
             * @ticketRemove 增加项删除
             */
            ticketRemove(targetId) {
                this.selectedTicketsRowKeys = this.selectedTicketsRowKeys.filter(item => item !== targetId);
                this.dataSourceTickets = this.dataSourceTickets.filter(item => item.targetId !== targetId);
            },
            /**
             * @batchTicketRemove 批量增加项删除
             */
            batchTicketRemove() {
                this.selectedDeleteRowKeys.forEach(deleteItem => {
                    this.selectedTicketsRowKeys.forEach((item,index) => {
                        if(item == deleteItem) {
                            this.dataSourceTickets.splice(index,1);
                            this.selectedTicketsRowKeys.splice(index,1);
                        }
                    })
                })
                this.selectedDeleteRowKeys = [];
            },
            onSelectChange(selectedDeleteRowKeys) {
                this.selectedDeleteRowKeys = selectedDeleteRowKeys;
            },
            // 系统线上票券获取
            getTicket() {
                if (!this.shopId) return;
                this.$api.changeCode.getOnlineTicket({
                    body: {
                        pageSize: 9999,
                        pageNum: 1,
                        suitShopId: this.shopId,
                    }
                }).then(res => {
                    res.list && res.list.forEach(el => {
                        // el.ticketId = el.ticketTemplateId;
                        el.ticketName = el.name;
                        el.ticketType = el.type;
                        el.sellPrice = el.sellShowPrice;
                        el.id = el.ticketTemplateId;
                    });
                    this.ticketList = res.list;
                });
            },
            // 获取票台列表
            getNewPlatformList() {
                if (!this.shopId) return
                this.$api.ticketDesk.cashPayPlatform({
                    body: {
                        pageNum: 1,
                        pageSize: 9999,
                        shopId: this.shopId == -1 ? undefined : this.shopId
                    }
                }).then(res => {
                    this.ticketDeskNew = [];
                    res.list.forEach(item => {
                        this.ticketDeskNew.push({label: item.name, value: item.id})
                    })
                });
            },
            deleteData(id) {
                this.tableSelectedRowKeys = this.tableSelectedRowKeys.filter(item => item != id);
                this.dataSource = this.dataSource.filter(item => item.id != id);
            },
            // 将子组件或者详情里选中的门店票ID数组转化为表格数据
            getTableData(list) {
                this.dataSource = [];
                list.forEach(item => {
                    this.ticketList.forEach(ticket => {
                        if(item == ticket.ticketTemplateId) {
                            let { ticketTemplateId } = ticket;
                            this.dataSource.push({...ticket, id: ticketTemplateId, targetId: ticketTemplateId});
                        }
                    })
                })
            },
            onSubmit() {
                this.form.validateFields((err, values) => {
                    if (err) return
                    values.shelveStartDate = values.shelveDate[0].format("YYYY-MM-DD");
                    values.shelveEndDate = values.shelveDate[1].format("YYYY-MM-DD");
                    delete values.shelveDate;

                    if(values.discountRange === 2 && this.$route.query.discountTarget == 1 && !this.dataSource.length) {
                        this.$message.error('请选择票券！');
                        return
                    }
                    if(values.discountRange === 2 && this.$route.query.discountTarget == 2 && !this.dataSource.length) {
                        this.$message.error('请选择零售商品！');
                        return
                    }

                    if(values.useLimit === 1 && this.selectedTicketsRowKeys.length === 0) {
                        this.$message.error('请选择持使用限制的持有票券！');
                        return
                    }
                    if(values.utLimit === 1 && !values.utLimitNum) {
                        this.$message.error('请输入限制使用次数！');
                        return
                    }
                    values.commonTicketIds = values.useLimit == 1 ? this.dataSourceTickets : [];

                    if(this.$route.query.discountTarget) { // 票券优惠
                        values.discountTargetIds = this.dataSource.map(item => {return item.id}).join(',');
                        values.discountTargetVos = this.dataSource.map(item => {item.targetId = String(item.id); return item});
                    } else {
                        values.discountTargetIds = '';
                        values.discountTargetVos = []
                    }

                    values.shelvePlatformIds = values.shelvePlatformIds.join(',');
                    values.id = this.$route.query.id;
                    values.discountTarget = this.$route.query.discountTarget;
                    values.shopId = this.shopId;

                    this.loading = true;
                    this.$api.changeCode.addOrModifyDiscount({
                        body: values
                    }).then(res => {
                        this.loading = false;
                        this.$message.success('操作成功');
                        this.$router.go(-1);
                    }).catch(err => {
                        this.loading = false;
                        this.$message.error('操作失败');
                    })
                })
            },
            getDetail() {
                this.$api.changeCode.detailDiscount({
                    params: {
                        id: this.$route.query.id
                    }
                }).then(res => {
                    let formValues = {
                        discountType: res.discountType,
                        name: res.name,
                        discountPercent: res.discountType === 1 ? res.discountPercent : undefined,
                        reduceAmount: res.discountType === 2 ? res.reduceAmount : undefined,
                        satisfy: res.satisfy || 0,
                        satisfyAmount: res.satisfy === 1 ? res.satisfyAmount : undefined,
                        discountRange: res.discountRange,
                        useLimit: res.useLimit,
                        shelvePlatformIds: res.shelvePlatformIdList,
                        shelveDate: [ this.$moment(res.shelveStartDate), this.$moment(res.shelveEndDate) ],
                        shelve: res.shelve,
                        holdMode: res.holdMode,
                        utLimit: res.utLimit,
                        utLimitMode: res.utLimitMode,
                        utLimitNum: res.utLimitNum,
                        utLimitTime: res.utLimitTime
                    };
                    this.showDiscount = res.discountType === 1;
                    this.showStandard = res.satisfy === 1;
                    this.selectedTicketsRowKeys = [];
                    if (res.commonTicketIds && Array.isArray(res.commonTicketIds)) {
                        res.commonTicketIds.map(item => {
                            item.targetId = item.ticketId;
                            this.selectedTicketsRowKeys.push(item.targetId);
                            return item;
                        })
                        this.dataSourceTickets = res.commonTicketIds;
                    }
                    this.getTableData(res.discountTargetIdList || []);
                    this.tableSelectedRowKeys = res.discountTargetIdList || [];
                    if(res.discountRange === 2) {
                        this.dataSource = res.discountTargetVos.map(item => {item.id = item.targetId; return item})
                        this.selectedRowKeys = res.discountTargetIdList || [];
                    }
                    this.$nextTick(() => {
                        this.form.setFieldsValue(formValues);
                        this.spinning = false;
                    })
                })
            },
            /**
            * @goodsLimitOnchange 优惠券使用限制表格选择变更事件
             */
            goodsLimitOnchange(selectedRowKeys, selectedRows) {
                this.goodsLimitSelectedDeleteRowKeys = selectedRowKeys;
            },
            /**
            * @goodsLimitOnSelectAll 优惠券使用限制表格全选/取消全选变更事件
             */
            goodsLimitOnSelectAll(selected, selectedRows, changeRow) {
                if (selected) {
                    this.goodsLimitSelectedDeleteRowKeys = this.dataSource.map(i => i.id);
                } else {
                    this.goodsLimitSelectedDeleteRowKeys = [];
                }
            },
            /**
            * @goodsLimitDelete 优惠券使用限制商品删除选中的
             */
            goodsLimitDelete() {
                this.dataSource = this.dataSource.filter((i) => {
                    return !Boolean(this.goodsLimitSelectedDeleteRowKeys.find(item => String(item) === String(i.id)));
                });
                let sk = this.dataSource.map(i => i.id);
                this.tableSelectedRowKeys = sk;
                this.selectedRowKeys = sk;
                this.goodsLimitSelectedDeleteRowKeys = [];
            },
        }
    }
</script>
